import React, { ReactElement } from 'react';

export interface FavoriteStarFilledIconProps {
  style?: React.CSSProperties;
  fill?: string;
}

export const FavoriteStarFilledIcon = ({
  style,
  fill = '#fff',
}: FavoriteStarFilledIconProps): ReactElement => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" style={style}>
      <path
        d="M2.88275 14.3652L4.12325 9.05175L0 5.48075L5.43075 5.0095L7.55775 0L9.68475 5.0095L15.1155 5.48075L10.9923 9.05175L12.2327 14.3652L7.55775 11.5442L2.88275 14.3652Z"
        fill={fill}
      />
    </svg>
  );
};
